import { create } from "zustand"

interface InboxAnchorResetState {
	resetKey: number
	resetInboxAnchor: () => void
}

// Bumped right before a bulk mutation removes many rows from the current tab.
// Feeding resetKey into the inbox virtualizer's listContextParams re-anchors
// the list to the top, so zero-virtual never keeps a backward anchor pointing
// at rows the mutation just deleted (that state throws "Assertion failed").
export const useInboxAnchorReset = create<InboxAnchorResetState>((set) => ({
	resetKey: 0,
	resetInboxAnchor: () => set((s) => ({ resetKey: s.resetKey + 1 })),
}))
